import  { STORE_SOLACE_CREDENTIALS } from '../actions/storeSolaceCredentialsActions';;

export const storeSolaceCredentialsReducer= (
	state: any = {},
	action: any
): any => {
	switch (action.type) {
		case STORE_SOLACE_CREDENTIALS:
			return action.payload;
		default:
			return state;
	}
}

